import React from 'react';
import { Helmet } from 'react-helmet-async';
import { TEXTS } from '@/constants/texts';

// ========================================
// LEGAL NOTICE PAGE
// ========================================

export const MentionsLegales: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <Helmet>
                <title>Legal Notice - {TEXTS.landing.title}</title>
                <meta name="description" content="Legal Notice of Get My News" />
            </Helmet>

            <div className="legal-page">
                <div className="legal-page__container">
                    <header className="legal-page__header">
                        <a href="/" className="legal-page__back-link">
                            ← Back
                        </a>
                        <h1 className="legal-page__title">Legal Notice</h1>
                    </header>

                    <main className="legal-page__content">
                        <section className="legal-page__section">
                            <h2>Publisher</h2>
                            <p>
                                <strong>Company Name:</strong> Get My News<br />
                                <strong>Legal Form:</strong> In process of creation<br />
                                <strong>Headquarters:</strong> To be determined<br />
                                <strong>Email:</strong> contact@get-my-news.com
                            </p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Hosting</h2>
                            <p>
                                This website is hosted by Netlify, Inc.<br />
                                2325 3rd Street, Suite 296<br />
                                San Francisco, California 94107<br />
                                United States
                            </p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Intellectual Property</h2>
                            <p>
                                All content on this website (text, images, logos) is the exclusive
                                property of Get My News, unless otherwise stated.
                            </p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Personal Data</h2>
                            <p>
                                For information regarding your personal data, please consult
                                our <a href="/politique-confidentialite">Privacy Policy</a>.
                            </p>
                        </section>
                    </main>

                    <footer className="legal-page__footer">
                        <p>© {currentYear} {TEXTS.landing.title}</p>
                    </footer>
                </div>
            </div>
        </>
    );
};

MentionsLegales.displayName = 'MentionsLegales';

export default MentionsLegales;
